import React, { useContext, useState } from "react";
import { AuthContext, DeveloperContext, PagesContext } from "../../context/authContext";
import MyMenuItem from "../UI/menuItem/MyMenuItem";
import { appPages } from "../../common/links";
import MyModal from "../UI/modal/MyModal";
import AllForecastModalBody from "../forecast/allForecastModalBody";

const Menu = function(){
    const {isAuthenticated, setIsAuthenticated, isLoading} = useContext(AuthContext);
    const {page, setPage} = useContext(PagesContext);
    const { isDevMode } = useContext(DeveloperContext);
    const clearAccess = function(){
        localStorage.setItem("accessToken", "");
    }
    const clearRefresh = function(){
        localStorage.tabssetItem("refreshToken", "");
    }
    const logout = function(){
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        setIsAuthenticated(false);
    }
    const invalidateAccess = function(){
        localStorage.setItem(
            "accessToken", 
            "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDAwMzU1MzIsImdyb3VwcyI6W10sImlkIjozMDAyLCJyb2xlIjo2LCJ0aW1lem9uZSI6IiJ9.C-D9c9MVrZrjw0uPVd_MkRUPUEqJ6m-L41ZuuSmU1Rw");
    }
    const invalidateRefresh = function(){
        localStorage.setItem("refreshToken", "25fa7c08-7ff6-4d76-9d68-a7ebfa4a00f0");
    }

    const [modal, setModal] = useState(false);

    return (
        <div id="menu">
            {appPages.map(item => 
                <MyMenuItem onClick={() => setPage(item.state)} key={item.state}>
                    {item.text}
                </MyMenuItem>
            )}
            <MyMenuItem onClick={() => setModal(true)}>Создать прогноз</MyMenuItem>
            <MyModal
                visible={modal}
                setVisible={setModal}
                style={{ width: "50%" }}
            >
                <AllForecastModalBody modalKind={"POST"} closeSelf={setModal} />
            </MyModal>    
            {isDevMode
                ?
                <>
                    <MyMenuItem onClick={() => setIsAuthenticated(false)}>Разлогиниться</MyMenuItem>
                    <MyMenuItem onClick={() => clearAccess()}>Инвалидировать A</MyMenuItem>
                    <MyMenuItem onClick={() => clearRefresh()}>Инвалидировать R</MyMenuItem>
                    <MyMenuItem onClick={() => invalidateAccess()}>Просрочить A</MyMenuItem>
                    <MyMenuItem onClick={() => invalidateRefresh()}>Просрочить R</MyMenuItem>
                    <MyMenuItem onClick={() => logout()}>Выход</MyMenuItem>
                    {/* <MyMenuItem onClick={() => setPage("forecasts")} key={"forecasts"}>Прогнозы</MyMenuItem> */}
                </>
                : <></>
            }
        </div>
    );
}
export default Menu;